import request from '@/utils/request'

export const API_PROJECT_LIST = '/api/cmdb-template/web-project/list'
export const API_PROJECT_CHANGE = '/api/cmdb-template/web-project/change'
export const API_HOME_LIST = '/api/cmdb-template/web-project/count'
export const API_MENU_LIST = '/api/cmdb-template/auth/menu'
export const API_DOCTOR_LIST = '/api/cmdb-template/web-project/current-project-tenant-doctors'
export const API_USER_INFO = '/api/cmdb-template/sys-user/user-info'
export const API_USER_INFO_OPERATE = '/api/cmdb-template/sys-user'
export const API_SYS_FIELD = '/api/cmdb-template/sys-field-dict-option/page'
export const API_PATIENT_INFO = '/api/cmdb-template/patient-info/'
export const API_PATIENT_DELETE = '/api/cmdb-template/patient-info'
export const API_UPLOAD = '/api/cmdb-template/oss/file/upload-file'
export const API_UPLOADS = '/api/cmdb-template/oss/file/upload-files'
export const API_QR_CODE = '/api/cmdb-template/ocr-bulk-upload-record/qr-code'
export const API_PROJECT_INFO = '/api/cmdb-template/web-project/current'
export const API_USER_CONFIG = '/api/cmdb-template/page-config-custom'
export const API_TENANT_LIST = '/api/cmdb-template/web-project/org-list'
export const API_AREA_LIST = '/api/cmdb-template/sys-area/page'
export const API_AREA_TREE = '/api/cmdb-template/sys-area/tree'
export const API_PROJECT_SEARCT_JOIN = '/api/cmdb-template/web-project/search4join'


export function changeProjectByCode(projectCode: string) {
  return request({
    url: '/api/cmdb-template/web-project/change-by-code',
    method: "GET",
    params: { projectCode }
  })
}

export function getProjectList(id:any = '') {
  return request({
    url: API_PROJECT_LIST + (id? `/${id}` : ''),
    method: "POST",
  })
}

export function getDoctorList() {
  return request({
    url: API_DOCTOR_LIST,
    method: "GET"
  })
}

export function changeProject(params: any) {
  return request({
    url: API_PROJECT_CHANGE,
    method: "GET",
    params
  })
}

export function getHomeList(id: any) {
  return request({
    url: API_HOME_LIST,
    method: "GET"
  })
}


export function getMenuList(params: any) {
  return request({
    url: API_MENU_LIST,
    method: "GET",
    params
  })
}

export function getUserInfo() {
  return request({
    url: API_USER_INFO,
    method: "GET"
  })
}

export function getSysField(data: any) {
  return request({
    url: API_SYS_FIELD,
    method: "POST",
    data
  })
}

export function getPatientInfo(id: any, projectCode?: string) {
  return request({
    url: API_PATIENT_INFO + id,
    method: "GET",
    params: projectCode ? { projectCode } : undefined
  })
}

export function uploadFile(data: any) {
  return request({
    url: API_UPLOAD,
    method: "POST",
    data
  })
}

export function uploadFiles(data: any) {
  return request({
    url: API_UPLOADS,
    method: "POST",
    data
  })
}

export function qrCodeGet(params: any) {
  return request({
    url: API_QR_CODE,
    method: "GET",
    responseType: "blob",
    params
  })
}

export function getProjectInfo() {
  return request({
    url: API_PROJECT_INFO,
    method: "GET"
  })
}

export function getUserConfig(params: any) {
  return request({
    url: API_USER_CONFIG,
    method: "GET",
    params
  })
}

export function setUserConfig(data: any) {
  return request({
    url: API_USER_INFO_OPERATE,
    method: "PUT",
    data
  })
}

export function saveUserConfig(data: any) {
  return request({
    url: API_USER_CONFIG,
    method: "POST",
    data
  })
}

export function delUserConfig(params: any) {
  return request({
    url: API_USER_CONFIG,
    method: "DELETE",
    params
  })
}

export function getTenantList(params: any) {
  return request({
    url: API_TENANT_LIST,
    method: "GET",
    params
  })
}

export function deletePatient(params: any) {
  return request({
    url: API_PATIENT_DELETE,
    method: "DELETE",
    params
  })
}

export function getAreaList(data: any) {
  return request({
    url: API_AREA_LIST,
    method: "POST",
    data
  })
}

export function getAreaTree() {
  return request({
    url: API_AREA_TREE,
    method: "POST",
    data: {}
  })
}

export function joinSubProject(data: any) {
  return request({
    url: API_PROJECT_SEARCT_JOIN,
    method: "POST",
    data
  })
}
